import CreatorDetails from '@square/dashboard-data/models/squareup/beemo/api/v2/models/creator-details';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Employee from '@square/dashboard-data/models/squareup/bills/employee';
import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
const AppointmentStaff = ProtoBaseModel.extend({
  employee: attr(Employee)
});
const AppointmentsDetails = ProtoBaseModel.extend({
  appointmentsId: attr(String),
  appointmentStaff: attr(AppointmentStaff)
});
const Invoice = ProtoBaseModel.extend({
  invoiceTokenPair: attr(TokenPair)
});
const OwnershipTransferDetails = ProtoBaseModel.extend({
  transferToEmployee: attr(Employee)
});
const LifecycleEvent = ProtoBaseModel.extend({
  ownershipTransferDetails: attr(OwnershipTransferDetails)
});
const OpenTicket = ProtoBaseModel.extend({
  name: attr(String),
  ticketOwner: attr(CreatorDetails)
});
export default ProtoBaseModel.extend({
  appointmentsDetails: attr(AppointmentsDetails),
  invoice: attr(Invoice),
  lifecycleEvent: repeated(LifecycleEvent),
  openTicket: attr(OpenTicket)
});